import { client } from '../../../../../actions';
import { authHeader } from '../../../../../helpers/auth-header';

export const fetchAdminInfoFieldTypes = async () => {
  const response = await client.get('/Admin/company/field_types', {
    headers: authHeader(),
  });

  return response.data;
};
